import { useQuery } from "react-query";
import { api, ApiError } from "utils/api";
import type { ReviewResponse } from "../types";

const getReviews = (objectType: "ARTIST" | "PROJECT", objectId: string) =>
  api(
    `/${objectType === "ARTIST" ? "artists" : "projects"}/${objectId}/reviews`
  );

const useReviews = (objectType: "ARTIST" | "PROJECT", objectId: string) =>
  useQuery<ReviewResponse, ApiError>(
    [objectType, objectId, "reviews"],
    () => getReviews(objectType, objectId),
    {
      enabled: !!(objectId && objectType),
    }
  );

export { useReviews };
